import { IFsMap } from '../types';

export abstract class FsMapTrafficServiceProvider<TMap extends IFsMap> {
  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
}
